import React from "react";
import {getDateInFrench} from "../../utils/dateUtils";
import styled from "styled-components";

const ContainerLastUpdatedItem = ({title, getDataByField, field, entityClass}) => {
    return (
        <Container>
            <h5>{title} : </h5>
            <p> {getDataByField(field, entityClass).hour} </p>
            <p> {getDateInFrench(getDataByField(field, entityClass).date)} </p>

        </Container>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  height: 35px;
  min-width: 250px;
  width: 100%;
  border-bottom: 0.2px solid var(--color-grey-03);
  h5 {
    width: 50%;
    font-weight: 500;
    font-size: 0.8rem;
  }
  p {
    font-size: 0.8rem;
    padding-left: 1em;
    padding-right: 1em;
  }
`
export default ContainerLastUpdatedItem;